import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { Location, Guest, Transaction } from "../types";
import type { DinerProfile } from "../types/diner";
import { logout } from "./userSlice";
import { TicketData } from "../../web-redemption/type";

interface CheckoutState {
  selectedLocation: Location | null;
  dinerProfile: DinerProfile | null;
  ticketData: TicketData | null;
  selectedGuest: Guest | null;
  toBeRefunded: Transaction | null;
  notes: string;
}

const initialState: CheckoutState = {
  selectedLocation: null,
  dinerProfile: null,
  ticketData: null,
  selectedGuest: null,
  toBeRefunded: null,
  notes: "",
};

const checkoutSlice = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    setSelectedLocation(state, action: PayloadAction<Location | null>) {
      state.selectedLocation = action.payload;
    },
    setDinerProfile(state, action: PayloadAction<DinerProfile | null>) {
      state.dinerProfile = action.payload;
    },
    setTicketData(state, action: PayloadAction<TicketData | null>) {
      state.ticketData = action.payload;
    },
    setSelectedGuest(state, action: PayloadAction<Guest | null>) {
      state.selectedGuest = action.payload;
    },
    setToBeRefunded(state, action: PayloadAction<Transaction | null>) {
      state.toBeRefunded = action.payload;
    },
    setNotes(state, action: PayloadAction<string>) {
      state.notes = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      state.selectedLocation = null;
      state.dinerProfile = null;
      state.ticketData = null;
      state.selectedGuest = null;
      state.toBeRefunded = null;
      state.notes = "";
    });
  },
});

export const {
  setSelectedLocation,
  setDinerProfile,
  setTicketData,
  setSelectedGuest,
  setToBeRefunded,
  setNotes,
} = checkoutSlice.actions;

export default checkoutSlice.reducer;
